import { useState } from 'react';

export default function DownloadSection() {
  const [activeTab, setActiveTab] = useState<'android' | 'ios'>('android');

  return (
    <section id="download" className="py-14 md:py-20 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20gradient%20background%20with%20soft%20abstract%20geometric%20shapes%20in%20coral%20and%20amber%20tones%2C%20subtle%20manga%20panel%20lines%20fading%20into%20the%20background%2C%20clean%20modern%20minimalist%20style%2C%20warm%20inviting%20atmosphere%2C%20soft%20lighting&width=1600&height=600&seq=download-bg-manga&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-background-900/85"></div>
      </div>

      <div className="relative px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-background-50 mb-4">
              下载亲亲漫画APP
            </h2>
            <p className="text-sm md:text-base text-background-50/70 mb-8 leading-relaxed max-w-md">
              支持安卓与iOS双平台，海量韩漫、日漫、国漫免费看。下拉式阅读更流畅，支持离线缓存，随时随地想看就看！
            </p>

            <div className="flex flex-wrap gap-4 mb-8">
              <div className="flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-check-line text-accent-400"></i>
                </div>
                <span className="text-sm text-background-50/80">高清画质</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-check-line text-accent-400"></i>
                </div>
                <span className="text-sm text-background-50/80">下拉式阅读</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-check-line text-accent-400"></i>
                </div>
                <span className="text-sm text-background-50/80">离线缓存</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-check-line text-accent-400"></i>
                </div>
                <span className="text-sm text-background-50/80">每日追更提醒</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-check-line text-accent-400"></i>
                </div>
                <span className="text-sm text-background-50/80">个性化推荐</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-check-line text-accent-400"></i>
                </div>
                <span className="text-sm text-background-50/80">完全免费</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 items-start">
              <div className="bg-background-50/10 backdrop-blur-sm rounded-2xl p-5 border border-background-50/10">
                <div className="flex items-center gap-3 mb-4">
                  <button
                    onClick={() => setActiveTab('android')}
                    className={`px-5 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                      activeTab === 'android'
                        ? 'bg-primary-500 text-background-50'
                        : 'text-background-50/60 hover:text-background-50/90'
                    }`}
                  >
                    <div className="w-4 h-4 flex items-center justify-center inline-block mr-1.5 -mt-0.5 align-middle">
                      <i className="ri-android-line"></i>
                    </div>
                    安卓版
                  </button>
                  <button
                    onClick={() => setActiveTab('ios')}
                    className={`px-5 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                      activeTab === 'ios'
                        ? 'bg-primary-500 text-background-50'
                        : 'text-background-50/60 hover:text-background-50/90'
                    }`}
                  >
                    <div className="w-4 h-4 flex items-center justify-center inline-block mr-1.5 -mt-0.5 align-middle">
                      <i className="ri-apple-line"></i>
                    </div>
                    iOS版
                  </button>
                </div>

                <div className="flex items-center gap-4">
                  <div className="w-28 h-28 bg-background-50 rounded-xl flex items-center justify-center">
                    <div className="w-24 h-24 flex items-center justify-center">
                      <i className="ri-qr-code-line text-6xl text-foreground-800"></i>
                    </div>
                  </div>
                  <div>
                    <p className="text-sm text-background-50/80 mb-3">扫码下载{activeTab === 'android' ? '安卓' : 'iOS'}APP</p>
                    <a
                      href="#"
                      className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-accent-500 text-background-50 text-sm font-medium hover:bg-accent-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                    >
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-download-line"></i>
                      </div>
                      {activeTab === 'android' ? 'APK下载' : 'App Store'}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="hidden lg:flex justify-center">
            <div className="relative">
              <div className="w-[220px] h-[440px] bg-background-800 rounded-[2rem] p-2 shadow-2xl">
                <div className="w-full h-full bg-background-100 rounded-[1.5rem] overflow-hidden flex flex-col">
                  <div className="h-10 bg-background-900 flex items-center justify-center">
                    <span className="text-[10px] text-background-50/60">亲亲漫画</span>
                  </div>
                  <div className="flex-1 p-3 space-y-2">
                    {[1, 2, 3, 4].map((i) => (
                      <div key={i} className="flex gap-2 p-2 rounded-lg bg-background-50">
                        <div className="w-10 h-14 bg-background-200 rounded flex-shrink-0"></div>
                        <div className="flex-1 space-y-1.5">
                          <div className="h-3 bg-background-200 rounded w-3/4"></div>
                          <div className="h-2 bg-background-200 rounded w-1/2"></div>
                          <div className="h-2 bg-background-200 rounded w-1/3"></div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="h-12 bg-background-900 flex items-center justify-around">
                    {[1, 2, 3, 4].map((i) => (
                      <div key={i} className="w-6 h-6 bg-background-700 rounded-full"></div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="absolute -top-4 -right-4 w-16 h-16 rounded-2xl bg-accent-500 flex items-center justify-center shadow-lg rotate-12">
                <span className="text-background-50 text-[10px] font-bold text-center leading-tight">免费<br/>下载</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}